import React from 'react';
import Logo from '../images/CD-Icons-02-white.png';
export default function Loading(props) {
    return (
        <div className="loading">
            <img src={Logo} alt="logo"/>
        </div>
    )
}